/**
 * NDL Debug Logger
 * Eine einfache Debug-Logging-Funktion für Shopify-Themes
 * 
 */

// Erstelle ein globales Objekt für die Debug-Funktionalität
window.NDLDebug = {
    // Prüft, ob Debug-Logging aktiviert ist
    isDebugEnabled: function() {
        return window.theme && 
               window.theme.settings && 
               window.theme.settings.ndl_debug_enabled === true;
    },
    
    // Einfache Debug-Logging Funktion
    log: function(...args) {
        if (this.isDebugEnabled()) {
            // Hole den Script-Namen aus dem Stack Trace
            const stack = new Error().stack;
            const scriptName = stack.split('\n')[2]?.match(/\((.+?):\d+:\d+\)/)?.[1]?.split('/').pop() || 'Unknown Script';
            console.log(`[${scriptName}]`, ...args);
        }
    }
};

// Globale debugLog Funktion für einfachen Zugriff
window.debugLog = function(...args) {
    return window.NDLDebug.log(...args);
}; 